export enum PageKey {
  LOGIN = 'login',
  USERS = 'users',
  ANALYSIS = 'manual-analysis',
  COMPARISON = 'comparison',
  MANAGE = 'manage',
  INFORM = 'inform'
}
